"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _layout = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/layout"));
var _linebreaker = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/engines/linebreaker"));
var _justification = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/engines/justification"));
var _textDecoration = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/engines/textDecoration"));
var _scriptItemizer = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/engines/scriptItemizer"));
var _wordHyphenation = _interopRequireDefault(require("@surge-global-engineering/rpdf-textkit/lib/engines/wordHyphenation"));
var _fontSubstitution = _interopRequireDefault(require("./fontSubstitution"));
var _getAttributedString = _interopRequireDefault(require("./getAttributedString"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var engines = {
  linebreaker: _linebreaker.default,
  justification: _justification.default,
  textDecoration: _textDecoration.default,
  scriptItemizer: _scriptItemizer.default,
  wordHyphenation: _wordHyphenation.default,
  fontSubstitution: _fontSubstitution.default
};
var engine = (0, _layout.default)(engines);
var getMaxLines = R.path(['style', 'maxLines']);
var getTextOverflow = R.path(['style', 'textOverflow']);

/**
 * Get layout container for specific text node
 *
 * @param {Number} width
 * @param {Number} height
 * @param {Object} node
 * @returns {Object} layout container
 */
var getContainer = function getContainer(width, height, node) {
  var maxLines = getMaxLines(node);
  var textOverflow = getTextOverflow(node);
  return {
    x: 0,
    y: 0,
    width: width,
    maxLines: maxLines,
    height: height || Infinity,
    truncateMode: textOverflow
  };
};

/**
 * Get text layout options for specific text node
 *
 * @param {Object} node instance
 * @param {Array} maskRects maskRects
 * @returns {Object} layout options
 */
var getLayoutOptions = function getLayoutOptions(fontStore, node, maskRects) {
  return {
    hyphenationPenalty: node.props.hyphenationPenalty,
    shrinkWhitespaceFactor: {
      before: -0.5,
      after: -0.5
    },
    hyphenationCallback: node.props.hyphenationCallback || (fontStore === null || fontStore === void 0 ? void 0 : fontStore.getHyphenationCallback()) || null,
    maskRects: maskRects
  };
};

/**
 * transform lines to include text length upto that line
 *
 * @param {Array} lines
 * @returns {Array} layout lines
 */
var linesWithRange = function linesWithRange(lines) {
  var strLength = 0;
  for (var i = 0; i < lines.length; i++) {
    lines[i].textBefore = strLength;
    strLength += lines[i].string.length;
  }
  return lines;
};

/**
 * Get text lines for given node
 *
 * @param {Object} node
 * @param {Array} maskRects
 * @param {Number} container width
 * @param {Number} container height
 * @param {Number} fontStore font store
 * @returns {Array} layout lines
 */
var layoutText = function layoutText(node, maskRects, width, height, fontStore) {
  var attributedString = (0, _getAttributedString.default)(fontStore, node);
  var container = getContainer(width, height, node);
  var options = getLayoutOptions(fontStore, node, maskRects);
  var lines = engine(attributedString, container, options);
  lines = lines.map(linesWithRange);
  return R.reduce(R.concat, [], lines);
};
var _default = exports.default = R.curryN(5, layoutText);